/**
 * Faz 8 — Android uygulaması satış raporu ekranı (F8-16) metinleri, Türkçe. `mobile.tr.ts`'e tek satırla eklenir
 * (ADR-801). Rapor tanımları panelin `admin.salesReport` / `admin.reports` metinleriyle ortaktır.
 */
export const mobileFaz8Tr = {
  salesReport: {
    title: 'Satış raporu',
    open: 'Satış raporunu aç',
    hint: 'Net satış, sipariş, ortalama sepet, yeni müşteri',
    presets: { today: 'Bugün', last_7: 'Son 7 gün', this_month: 'Bu ay', last_month: 'Geçen ay' },
    periodLabel: 'Dönem',
    netSales: 'Net satış',
    orders: 'Sipariş',
    averageOrder: 'Ortalama sepet',
    newCustomers: 'Yeni müşteri',
    deductions: 'İade ve iptal',
    itemsSold: 'Satılan adet',
    vsPrevious: 'önceki döneme göre {{change}}',
    up: '%{{pct}} artış',
    down: '%{{pct}} düşüş',
    flat: 'değişim yok',
    new: 'önceki dönemde yoktu',
    dailyTitle: 'Günlere göre',
    dailyRow: '{{orders}} sipariş',
    topProducts: 'En çok satan ürünler',
    productRow: '{{quantity}} adet',
    noSales: 'Bu dönemde satış yok.',
    partial: 'Dönem henüz bitmedi; bugünün rakamları gün içinde değişebilir.',
    awaiting: 'Ödeme bekleyen {{count}} sipariş ({{amount}}) satışa sayılmadı.',
    fxMissing: 'Kuru bulunamayan {{count}} döviz sipariş rapora katılmadı.',
    definition:
      'Kesinleşen siparişler (ödendi, hazırlanıyor, kargoda, teslim edildi, tamamlandı); tutarlar TL ve KDV dahil, iade ve iptal düşülmüş. Panelle aynı tanım.',
    morePanel: 'Kırılımlar, dosya ve finans raporu paneldedir.',
    noPermission: 'Satış rakamlarını görmek için satış raporları yetkisi gerekir.',
  },
};
